import React from 'react';

import { AgencyMonitoringDialog } from '../AgencyMonitoringDialog';
import { MonitoringHistoryDialog } from '../MonitoringHistoryDialog';
import { AgencyMonitoringDetailLogsDialog } from '../AgencyMonitoringDetailLogsDialog';
import type { AgencyMonitoringSuite } from '../../hooks/useAgencyMonitoringSuite';

type Props = AgencyMonitoringSuite;

/** Dialogs do fluxo Monitorar agências — montar uma vez por página. */
export function AgencyMonitoringSuiteDialogs({
  agencyMonitoringOpen,
  closeAgencyMonitoring,
  openAgencyMonitoringHistory,
  monitoringHistoryOpen,
  monitoringHistorySection,
  closeMonitoringHistory,
  agencyDetailLogsAgency,
  openAgencyDetailLogs,
  closeAgencyDetailLogs,
}: Props) {
  return (
    <>
      <AgencyMonitoringDialog
        open={agencyMonitoringOpen}
        onClose={closeAgencyMonitoring}
        onOpenGlobalHistory={openAgencyMonitoringHistory}
        onOpenAgencyLogs={openAgencyDetailLogs}
      />

      <MonitoringHistoryDialog
        open={monitoringHistoryOpen}
        onClose={closeMonitoringHistory}
        initialSection={monitoringHistorySection}
      />

      <AgencyMonitoringDetailLogsDialog
        open={!!agencyDetailLogsAgency}
        onClose={closeAgencyDetailLogs}
        agency={agencyDetailLogsAgency}
      />
    </>
  );
}
